import { denormalize, normalize } from 'normalizr'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import api from '../../api'
import createSlice from '../create-slice'
import { practiceOfficeLocationsSchema } from '../normalizr'
import { getPaginationHeaders } from '../utils'
import { getEntities } from './entities'

const practiceOfficeLocationsInitialState = {
  practiceOfficeLocationsIds: {},
  pagination: {},
}

const practiceOfficeLocationsSlice = createSlice({
  name: 'practiceOfficeLocations',
  initialState: practiceOfficeLocationsInitialState,
  reducers: {
    setPracticeOfficeLocations: (
      state,
      { payload: { result, id, pagination } },
    ) => {
      state.practiceOfficeLocationsIds[id] = result
      state.pagination = pagination
    },
  },
})

const { actions } = practiceOfficeLocationsSlice

const selectState = state => state[practiceOfficeLocationsSlice.name]

export function usePracticeOfficeLocation(id) {
  const { practiceOfficeLocationsIds } = useSelector(selectState)
  const entities = useSelector(getEntities)
  const practiceOfficeLocations = denormalize(
    practiceOfficeLocationsIds[id] || [],
    [practiceOfficeLocationsSchema],
    entities,
  )
  return practiceOfficeLocations
}

export function fetchPracticeOfficeLocations(id, page = 1, perPage = 10) {
  return async dispatch => {
    const { body, headers } = await api.practices.getPracticeOfficeLocations(
      id,
      { paginated: true, page, perPage },
    )
    dispatch(
      actions.setPracticeOfficeLocations({
        ...normalize(body, [practiceOfficeLocationsSchema]),
        id,
        pagination: getPaginationHeaders(headers),
      }),
    )
  }
}

export function useFetchPracticeOfficeLocation(id, page, perPage) {
  const dispatch = useDispatch()

  return useCallback(() => {
    dispatch(fetchPracticeOfficeLocations(id, page, perPage))
  }, [dispatch, id, page, perPage])
}

export function addPracticeOfficeLocation(practiceId, data) {
  return api.practices.addPracticeOfficeLocation(practiceId, data)
}

export function deletePracticeOfficeLocation(practiceId, dataId) {
  return api.practices.deletePracticeOfficeLocation(practiceId, dataId)
}

export function updatePracticeOfficeLocation(practiceId, dataId, updatedData) {
  return api.practices.updatePracticeOfficeLocation(
    practiceId,
    dataId,
    updatedData,
  )
}

export function usePracticeOfficeLocationPagination() {
  const { pagination } = useSelector(selectState)
  return pagination
}

export default practiceOfficeLocationsSlice
